let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("auQ6U")).then(() => parcelRequire('7R5AD'));